<template>
  <o-dialog
    ref="dialog"
    :title="$t('form.addNew')"
    :info="info"
    :options="[
      { text: $t('general.back'), type: 'cancel' },
      { text: $t('general.add'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
  >
    <div class="pt-4 text-left">
      <o-form ref="formRef">
        <o-field-group
          v-if="select"
          v-slot="{ status }"
          :label="$t('general.form')"
          :name="$t('general.form')"
          class="mb-4 block"
          rules="required"
        >
          <form-select v-model="form" :status="status" class="w-full mt-1" />
        </o-field-group>

        <div v-if="!select && form" class="mb-4 w-full p-3 border rounded-lg">
          <p class="text-gray-600 text-xs">
            {{ $t('general.form') }}
          </p>
          <p class="text-gray-800 font-semibold text-sm">
            {{ form.title }}
          </p>
        </div>

        <div class="m-2">
          <o-field-group>
            <checkbox-field v-model="prefill" :label="$t('form.prefill')" :info="$t('form.prefillInfo')" label-class="text-sm w-full ml-2 opacity-90 flex justify-between items-center" />
          </o-field-group>
        </div>
      </o-form>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import FormSelect from '@/components/form/elements/Select.vue'
import { CheckboxField } from '@/components/fields'


interface Props {
  customer: any
  reservation?: any
  portal?: string
  loading?: boolean
  select?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success', response: any): void
  (e: 'error'): void
}

const props = withDefaults(defineProps<Props>(), {
  reservation: null,
  portal: undefined,
  loading: false,
  select: true,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification, $panel } = useNuxtApp()

const dialog = ref<any>()
const formRef = ref<any>()
const form = ref<any>(false)
const prefill = ref(true)

const info = computed(() => {
  return 'Add a new form'
})

const open = (formArg: any) => {
  form.value = formArg
  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  const { customer, reservation } = props

  const options = {
    customer,
    reservation,
    form: form.value,
    prefill: prefill.value,
  }

  try {
    const response = await $api.customerForm.getDefaults({
      formId: form.value?.idForm,
      customerId: customer?.idCustomer,
      reservationId: reservation?.idReservation,
      prefill: prefill.value,
    })

    if (response.data) {
      emit('success', response.data)
      const path = '/customer/form/add'
      const panelOptions = {
        props: {
          defaults: response.data,
        },
      }
      ;($panel as any).create(path, panelOptions)
      return true
    }
  } catch (e) {
    emit('error')
    $notification.toast({
      title: $i18n.t('general.error'),
      text: $i18n.t('form.requestErrorInfo'),
    })
  }
}

defineExpose({ open })
</script>
